import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/investment-target`;

export async function getAllocationTargets() {
  const res = await apiFetch(BASE_URL);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function saveAllocationTargets(targets) {
  const res = await apiFetch(BASE_URL, {
    method: "PUT",
    body: JSON.stringify(targets || []),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Failed to save targets");
  }
  return res.json();
}
